import { useContext } from "react";
import { AuthContext, type AuthState } from "./AuthProvider";

/**
 * Read auth state from any component inside <AuthProvider>.
 * Throws a developer-friendly error if used outside the provider tree.
 */
export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }
  return ctx;
}
